export default [
    {
        path: '/otp/redirect/:path*',
        component: () => import('./otp/views/redirect/index')
    },
    {
        path: '/otp/index',
        name: 'personManage',
        meta: { title: 'otp.route.personManage', icon: 'dispatchPopup', system: 'tms' },
        component: () => import('./otp/views/manageDesk/Index')
    },
    // {
    //     path: '/otp/order-manage',
    //     name: 'orderManage',
    //     component: () => import('./otp/views/orderManage/Index'),
    //     meta: { title: 'otp.route.orderManage', icon: 'dispatchPopup', system: 'tms' },
    //     children: [
    //         {
    //             path: '/otp/order-manage/alibaba-services',
    //             name: 'alibabaServices',
    //             component: () => import('./otp/views/orderManage/aliServices/Index.vue'),
    //             meta: { title: 'otp.route.alibabaServices', icon: 'dispatchList', system: 'tms' }
    //         },
    //         {
    //             path: '/otp/order-manage/alibaba-services/edit/:id',
    //             name: 'alibabaServicesSingle',
    //             component: () => import('./otp/views/orderManage/aliServices/edit/Index.vue'),
    //             meta: { title: 'otp.route.alibabaServicesSingle', icon: 'dispatchList', system: 'tms' }
    //         },
    //         {
    //             path: '/otp/order-manage/task-center',
    //             name: 'taskCenter',
    //             component: () => import('./otp/views/orderManage/taskCenter/taskCenterList/Main.vue'),
    //             meta: { title: 'otp.route.taskCenter', icon: 'taskCenter', system: 'tms' }
    //         },
    //         {
    //             path: '/otp/order-manage/task-detail',
    //             name: '_taskCenterDetail',
    //             component: () => import('./otp/views/orderManage/taskCenter/taskCenterDetail/Main'),
    //             meta: { title: 'otp.route.taskCenterDetail', icon: 'taskCenterDetail', system: 'tms' }
    //         },
    //         {
    //             path: '/otp/order-manage/order-center',
    //             name: 'orderCenter',
    //             component: () => import('./otp/views/orderManage/orderCenter/orderCenterList/Main'),
    //             meta: { title: 'otp.route.orderCenter', system: 'tms' }
    //         },
    //         {
    //             path: '/otp/order-manage/order-detail',
    //             name: 'orderCenterDetail',
    //             component: () => import('./otp/views/orderManage/orderCenter/orderCenterDetail/Main'),
    //             meta: { title: 'otp.route.orderCenterDetail', icon: 'dispatchList', system: 'tms' }
    //         }
    //     ]
    // },
    {
        path: '/otp/dispatch',
        name: 'distributeManage',
        meta: { title: 'otp.route.distributeManage', icon: 'dispatchCenter', system: 'tms' },
        component: () => import('./otp/views/distributeManage/Index'),
        children: [
            {
                path: '/otp/order-panel',
                name: 'orderPanel',
                component: () => import('./otp/views/distributeManage/orderPanel/Index.vue'),
                meta: { title: 'otp.route.orderPanel', icon: 'orderPanel', system: 'tms' }
            },
            {
                path: '/otp/dispatch-center',
                name: 'dispatchCenter',
                component: () => import('./otp/views/distributeManage/dispatchCenter/DispatchCenter'),
                meta: { title: 'otp.route.dispatchCenter', icon: 'dispatchCenter', system: 'tms' }
            },
            // 可视化地图排车
            {
                path: '/distribute/visual-map-layout',
                name: 'visualMapLayout',
                component: () => import('./otp/views/distributeManage/visualMapLayout/Main'),
                meta: { title: 'otp.route.visualMapLayout', icon: 'visualMapLayout', system: 'tms' }
            },
            {
                path: '/otp/appointment-center',
                name: 'appointmentCenter',
                component: () => import('./otp/views/distributeManage/appointmentCenter/appointmentList/Main'),
                meta: { title: 'otp.route.appointmentCenter', icon: 'appointmentCenter', system: 'tms' }
            },
            {
                path: '/otp/appointment-center-detail',
                name: 'appointmentCenterDetails',
                component: () => import('./otp/views/distributeManage/appointmentCenter/appointmentDetail/Index'),
                meta: { title: 'otp.route.appointmentCenterDetail', icon: 'appointmentCenterDetail', system: 'tms' }
            },
            {
                path: '/otp/dispatch-order',
                name: 'dispatchOrder',
                component: () => import('./otp/views/distributeManage/dispatchOrderLists/dispatchOrder'),
                meta: { title: 'otp.route.dispatchOrder', icon: 'dispatchOrder', system: 'tms' }
            },
            {
                path: '/performance/dispatch-order',
                name: 'performanceDispatchOrder',
                meta: { title: 'otp.route.pDispatchOrder' },
                component: () => import('./otp/views/distributeManage/dispatchMgmt/Index')
            }, // 发车单管理(新) - 页面
            {
                path: '/performance/dispatch-order-detail',
                name: 'PerformanceDispatchInfo',
                meta: { title: 'otp.route.pDispatchOrderDetail' },
                component: () => import('./otp/views/distributeManage/dispatchMgmt/dispatchDetail/Index')
            }, // 发车单明细(新) - 页面
            {
                path: '/otp/waybill-node-monitor',
                name: 'PerformanceWaybillNodeMonitor',
                meta: { title: 'otp.route.pDispatchOrder', system: 'tms' },
                component: () => import('./otp/views/distributeManage/waybillNodeMonitor/Index')
            }, // 运单节点监控
            {
                path: '/otp/transfer-system',
                name: 'transferSystem',
                component: () => import('./otp/views/distributeManage/transferSystem/Index'),
                meta: { title: 'otp.route.transferSystem', icon: 'transferSystem', system: 'tms' }
            },
            {
                path: '/otp/receipt-center',
                name: 'receiptCenter',
                component: () => import('./otp/views/distributeManage/receiptCenter/Index'),
                meta: { title: 'otp.route.receiptCenter', icon: 'receiptCenter', system: 'tms' }
            },
            {
                path: '/otp/dispatch-order/dispatch-order-detail',
                name: 'dispatchOrderDetail',
                component: () => import('./otp/views/distributeManage/dispatchOrder/dispatchOrderDetail'),
                meta: { title: 'otp.route.dispatchOrderDetail', icon: 'dispatchOrderDetail', system: 'tms' }
            },
            {
                path: '/otp/distribute/vehicle-management',
                name: 'vehicleManagement',
                component: () => import('./otp/views/distributeManage/vehicleManagement/vehicleManagement'),
                meta: { title: 'otp.route.vehicleManagement', icon: 'vehicleManagement', system: 'tms' }
            },
            {
                path: '/otp/distribute/receipt-sign',
                name: 'receiptSign',
                component: () => import('./otp/views/distributeManage/receiptSign/index'),
                meta: { title: 'otp.route.receiptSign', icon: 'receiptSign', system: 'tms' }
            },
            {
                path: '/otp/distribute/transfer-create',
                name: 'transferCreate',
                component: () => import('./otp/views/distributeManage/transferCreate/index'),
                meta: { title: 'otp.route.transferCreate', icon: 'transferCreate', system: 'tms' }
            },
            {
                path: '/otp/distribute/transfer-confirm',
                name: 'transferConfirm',
                component: () => import('./otp/views/distributeManage/transferConfirm/index'),
                meta: { title: 'otp.route.transferConfirm', icon: 'transferConfirm', system: 'tms' }
            },
            {
                path: '/otp/distribute/vehicle-free-platform',
                name: 'otp.route.vehicleFreePlatform',
                component: () => import('./otp/views/distributeManage/vehicleFreePlatform/index'),
                meta: { title: 'otp.route.vehicleFreePlatform', icon: 'vehicleFreePlatform', system: 'tms' }
            },
            {
                path: '/otp/distribute/traffic-trajectory',
                name: 'trafficTrajectory',
                component: () => import('./otp/views/distributeManage/trafficTrajectory/trafficTrajectory'),
                meta: { title: 'otp.route.trafficTrajectory', icon: 'trafficTrajectory', system: 'tms' }
            },
            {
                path: '/otp/evaluate-query',
                name: 'evaluateQuery',
                component: () => import('./otp/views/distributeManage/evaluateQuery/Index.vue'),
                meta: { title: 'otp.route.evaluateQuery', icon: 'evaluateQuery', system: 'tms' }
            },
            {
                path: '/otp/distribute/transport-details',
                name: 'transportDetails',
                component: () => import('./otp/views/distributeManage/transportDetail/details/Main'),
                meta: { title: 'otp.route.transportDetails', icon: 'transportDetails', system: 'tms' }
            },
            {
                path: '/otp/distribute/transport-page',
                name: 'transportPage',
                component: () => import('./otp/views/distributeManage/transportDetail/index/Main'),
                meta: { title: 'otp.route.transportPage', icon: 'transportPage', system: 'tms' }
            },
            {
                path: '/performance/waybill-detail',
                name: 'waybillDetail',
                component: () => import('./otp/views/distributeManage/waybillManage/waybillDetail/Index'),
                meta: { title: 'otp.route.waybillDetail', icon: 'waybillDetail', system: 'tms' }
            },
            {
                path: '/order-manage/order-detail',
                name: 'orderManageOrderDetail',
                component: () => import('./otp/views/distributeManage/orderManageOrderDetail/Index'),
                meta: { title: 'otp.route.orderManageOrderDetail', icon: 'orderManageOrderDetail', system: 'tms' }
            },
            {
                path: '/order-manage/task-detail',
                name: 'orderManageTaskDetail',
                component: () => import('./otp/views/distributeManage/orderManageTaskDetail/Index'),
                meta: { title: 'otp.route.orderManageTaskDetail', icon: 'orderManageTaskDetail', system: 'tms' }
            },
            {
                path: '/performance/waybill-manage',
                name: 'waybillManage',
                component: () => import('./otp/views/distributeManage/waybillManage/Index'),
                meta: { title: 'otp.route.waybillManage', icon: 'waybillManage', system: 'tms' }
            },
            {
                path: '/otp/distribute/in-transit-tracking',
                name: 'inTransitTracking',
                component: () => import('./otp/views/distributeManage/inTransitTracking/Index'),
                meta: { title: 'otp.route.inTransitTracking', icon: 'inTransitTracking', system: 'tms' }
            },
            {
                path: '/otp/distribute/vehicle-transit-warning',
                name: 'vehicleTransitWarning',
                component: () => import('./otp/views/distributeManage/vehicleTransitWarning/Index'),
                meta: { title: 'otp.route.vehicleTransitWarning', icon: 'vehicleTransitWarning', system: 'tms' }
            },
            {
                path: '/otp/distribute/base-platoon',
                name: 'dispatchManageBasePlatoon',
                component: () => import('./otp/views/distributeManage/basePlatoon/Index'),
                meta: { title: 'otp.route.basePlatoon', icon: 'basePlatoon', system: 'tms' }
            },
            {
                path: '/otp/distribute/waybill-map-monitor',
                name: 'waybillMapMonitor',
                component: () => import('./otp/views/distributeManage/waybillMapMonitor/Index'),
                meta: { title: 'otp.route.waybillMapMonitor', icon: 'waybillMapMonitor', system: 'tms' }
            },
            {
                path: '/otp/distribute/dispatch-inRoad-monitor',
                name: 'dispatchInRoadMonitor',
                component: () => import('./otp/views/distributeManage/dispatchInRoadMonitor/Index'),
                meta: { title: 'otp.route.dispatchInRoadMonitor', icon: 'dispatchInRoadMonitor', system: 'tms' }
            },
            {
                path: '/otp/transport-center/driver-expense-manage',
                name: 'DriverExpenseManage',
                meta: { title: 'otp.route.DriverExpenseManage', icon: 'driverExpenseManage', system: 'tms' },
                component: () => import('./otp/views/transportCenter/driverExpenseManage/Index')
            }, // 运力中心-供应商运费管理
            {
                path: '/otp/transport-center/driver-expense-manage-mip',
                name: 'DriverExpenseManageMip',
                meta: { title: 'otp.route.DriverExpenseManageMip', icon: 'driverExpenseManageMip', system: 'tms' },
                component: () => import('./otp/views/transportCenter/driverExpenseManage/components/mipIframe')
            }, // 运力中心-供应商运费管理-异常申诉审批明细页
            {
                path: '/otp/transport-center/driver-payment-duration-config',
                name: 'DriverPaymentDurationConfig',
                meta: { title: 'otp.route.DriverPaymentDurationConfig', system: 'tms' },
                component: () => import('./otp/views/transportCenter/driverPaymentDurationConfig/Index')
            }, // 运力中心-司机收款时长配置
            {
                path: '/otp/transport-center/payment-duration-detail',
                name: 'PaymentDurationDetail',
                meta: { title: 'otp.route.PaymentDurationDetail', icon: 'paymentDurationDetail', system: 'tms' },
                component: () => import('./otp/views/transportCenter/driverPaymentDurationConfig/components/paymentDurationDetail/Index')
            }, // 运力中心-司机收款时长配置详情
            {
                path: '/otp/transport-center/payment-duration-mip',
                name: 'PaymentDurationMip',
                meta: { title: 'otp.route.PaymentDurationMip', icon: 'paymentDurationMip', system: 'tms' },
                component: () => import('./otp/views/transportCenter/driverPaymentDurationConfig/components/PaymentDurationMip')
            }, // 运力中心-司机收款时长配置审批详情
            {
                path: '/otp/transport-center/driver-expense-payment',
                name: 'DriverExpensePayment',
                meta: { title: 'otp.route.DriverExpensePayment' },
                component: () => import('./otp/views/transportCenter/driverExpensePayment/Index')
            }, // 运力中心-司机运费支付
            {
                path: '/otp/distribute/collusion-warning',
                name: 'PerformanceCollusionWarning',
                component: () => import('./otp/views/distributeManage/collusionWarning/Index.vue'),
                meta: { title: 'otp.route.PerformanceCollusionWarning', icon: 'vehicleTransitWarning', system: 'tms' }
            }, // 串货预警
            {
                path: '/otp/distribute/collusion-warning-detail',
                name: 'collusionWarningMap',
                meta: { title: 'otp.route.collusionWarningMap', icon: 'vehicleTransitWarning', system: 'tms' },
                component: () => import('./otp/views/distributeManage/collusionWarningMap/Index')
            }, // 串货预警明细 - 页面
            {
                path: '/otp/distribute/car-check',
                name: 'carCheck',
                meta: { title: 'otp.route.carCheck', system: 'tms' },
                component: () => import('./otp/views//distributeManage/carCheck/Main')
            } // 一车一检管理
        ]
    },
    {
        path: '/otp/config-center',
        name: 'configCenter',
        component: () => import('./otp/views/configCenter/Index'),
        children: [
            {
                path: '/otp/config-center/type',
                name: 'type',
                component: () => import('./otp/views/configCenter/typeClassification/Main'),
                meta: { title: 'otp.route.type', system: 'tms' }
            },
            {
                path: '/otp/config-center/charge',
                name: 'charge',
                component: () => import('./otp/views/configCenter/chargeRule/Main'),
                meta: { title: 'otp.route.charge', system: 'tms' }
            },
            {
                path: '/otp/config-center/distribution',
                name: 'distribution',
                component: () => import('./otp/views/configCenter/distributionRule/Main'),
                meta: { title: 'otp.route.distribution', system: 'tms' }
            },
            {
                path: '/otp/config-center/order-warhouse',
                name: 'orderWarhouse',
                component: () => import('./otp/views/configCenter/compartmentRule/Main'),
                meta: { title: 'otp.route.orderWarhouse', system: 'tms' }
            },
            {
                path: '/otp/config-center/thirdParty',
                name: 'thirdParty',
                component: () => import('./otp/views/configCenter/thirdParty/Main'),
                meta: { title: 'otp.route.thirdParty', system: 'tms' }
            },
            {
                path: '/otp/config-center/order-split',
                name: 'orderSplit',
                component: () => import('./otp/views/configCenter/demolitionRule/Main'),
                meta: { title: 'otp.route.orderSplit', system: 'tms' }
            },
            {
                path: '/otp/config-center/billing-service',
                name: 'billingService',
                component: () => import('./otp/views/configCenter/billingService/Main'),
                meta: { title: 'otp.route.billingService', system: 'tms' }
            },
            {
                path: '/otp/config-center/assignment',
                name: 'assignment',
                component: () => import('./otp/views/configCenter/taskDelivery/Main'),
                meta: { title: 'otp.route.assignment', system: 'tms' }
            },
            {
                path: '/otp/config-center/storehouse',
                name: 'storehouse',
                component: () => import('./otp/views/configCenter/storehouse/Main'),
                meta: { title: 'otp.route.storehouse', system: 'tms' }
            },
            {
                path: '/otp/config-center/wms',
                name: 'wms',
                component: () => import('./otp/views/configCenter/WMS/Main'),
                meta: { title: 'otp.route.wms', system: 'tms' }
            },
            {
                path: '/otp/config-center/upstream',
                name: 'upstream',
                component: () => import('./otp/views/configCenter/upstream/Main'),
                meta: { title: 'otp.route.upstream', system: 'tms' }
            },
            {
                path: '/otp/config-center/customer',
                name: 'customer',
                component: () => import('./otp/views/configCenter/customer/Main'),
                meta: { title: 'otp.route.customer', system: 'tms' }
            },
            {
                path: '/otp/config-center/area-rules',
                name: 'areaRules',
                component: () => import('./otp/views/configCenter/areaRules/Main'),
                meta: { title: 'otp.route.areaRules', system: 'tms' }
            },
            // {
            //     path: '/otp/config-center/mileage',
            //     name: 'mileage',
            //     component: () => import('./otp/views/configCenter/mileage/Main'),
            //     meta: { title: 'otp.route.mileage', system: 'tms' }
            // },
            {
                path: '/otp/config-center/shipment-quantity',
                name: 'shipmentQuantity',
                component: () => import('./otp/views/configCenter/shipmentQuantity/Main'),
                meta: { title: 'otp.route.shipmentQuantity', system: 'tms' }
            },
            {
                path: '/otp/config-center/virtual-customer',
                name: 'virtualCustomer',
                component: () => import('./otp/views/configCenter/virtualCustomer/Main'),
                meta: { title: 'otp.route.virtualCustomer', system: 'tms' }
            }
        ]
    },
    // {
    //     path: '/otp/report-manage',
    //     name: 'configCenter',
    //     component: () => import('./otp/views/reportManage/Index'),
    //     children: [
    //         {
    //             path: '/otp/report-manage/report-OMS',
    //             name: 'reportOMS',
    //             component: () => import('./otp/views/reportManage/ReportOMS'),
    //             meta: { title: 'otp.route.reportOMS', system: 'tms' }
    //         },
    //         {
    //             path: '/otp/report-manage/report-WMS',
    //             name: 'reportWMS',
    //             component: () => import('./otp/views/reportManage/ReportWMS'),
    //             meta: { title: 'otp.route.reportWMS', system: 'tms' }
    //         },
    //         {
    //             path: '/otp/report-manage/report-all',
    //             name: 'orderAllReport',
    //             component: () => import('./otp/views/reportManage/AllReport'),
    //             meta: { title: 'otp.route.reportAllOrder', system: 'tms' }
    //         }

    //     ]
    // },
    {
        path: '/otp/time-manage',
        name: 'timeManage',
        component: () => import('./otp/views/timeManage/Index'),
        children: [
            {
                path: '/otp/time-manage/aging-product',
                name: 'agingProduct',
                component: () => import('./otp/views/timeManage/agingProduct/Main'),
                meta: { title: 'otp.route.agingProduct', system: 'tms' }
            },
            {
                path: '/otp/time-manage/customer-prescription',
                name: 'customerPrescription',
                component: () => import('./otp/views/timeManage/customerPrescription/Main'),
                meta: { title: 'otp.route.customerPrescription', system: 'tms' }
            }
        ]
    },
    {
        path: '/otp/monitor-manage',
        name: 'monitorManage',
        component: () => import('./otp/views/monitorManage/Index'),
        children: [
            {
                path: '/otp/monitor-manage/order-exception',
                name: 'orderException',
                component: () => import('./otp/views/monitorManage/orderException/Main'),
                meta: { title: 'otp.route.orderException', system: 'tms' }
            },
            {
                path: '/otp/monitor-manage/omsc-exception',
                name: 'omscException',
                component: () => import('./otp/views/monitorManage/omscException/Main'),
                meta: { title: 'otp.route.omscException', system: 'tms' }
            }
        ]
    },
    {
        path: '/otp/base-info',
        name: '_baseInfo',
        component: () => import('./otp/views/baseInfo/Index'),
        children: [
            {
                path: '/otp/base-info/site-correction',
                name: '_siteCorrection',
                component: () => import('./otp/views/baseInfo/siteCorrection/Main'),
                meta: { title: 'otp.route.siteCorrection', system: 'tms' }
            }
        ]
    },
    {
        path: '/otp/stock-manage',
        name: 'stockManage',
        component: () => import('./otp/views/stockManage/Index'),
        children: [
            {
                path: '/otp/stock-manage/inventory-flow',
                name: 'inventoryFlow',
                component: () => import('./otp/views/stockManage/inventoryFlow/Main'),
                meta: { title: 'otp.route.inventoryFlow', system: 'tms' }
            },
            {
                path: '/otp/stock-manage/stock-adjust',
                name: 'stockAdjust',
                component: () => import('./otp/views/stockManage/stockAdjust/Main'),
                meta: { title: 'otp.route.stockAdjust', icon: 'stockAdjust', system: 'tms' }
            },
            {
                path: '/otp/stock-manage/stockCenter',
                name: 'stockAdjust',
                component: () => import('./otp/views/stockManage/stockCenter/Main'),
                meta: { title: 'otp.route.stockCenter', system: 'tms' }
            },
            {
                path: '/otp/stock-manage/accessStock',
                name: 'stockAdjust',
                component: () => import('./otp/views/stockManage/accessStock/Main'),
                meta: { title: 'otp.route.accessStock', system: 'tms' }
            },
            {
                path: '/otp/stock-manage/stockMove',
                name: 'stockMove',
                component: () => import('./otp/views/stockManage/stockMove/Main'),
                meta: { title: 'otp.route.stockMove', system: 'tms' }
            }
        ]
    },
    {
        path: '/otp/dispatch-manage',
        name: 'dispatchManage',
        component: () => import('./otp/views/dispatchManage/Index'),
        children: [
            {
                path: '/otp/dispatch-Manage/new-sieve-single-search',
                name: 'sieveSingleCenter',
                component: () => import('./otp/views/dispatchManage/newSieveSingleSearch/sieveSingleCenter'),
                meta: { title: 'otp.route.sieveSingleCenter', system: 'tms' }
            },
            {
                path: '/otp/dispatch-Manage/sieve-single-rule',
                name: 'sieveSingleRule',
                component: () => import('./otp/views/dispatchManage/sieveSingleRule/Main'),
                meta: { title: 'otp.route.sieveSingleRule', system: 'tms' }
            },
            {
                path: '/otp/dispatch-Manage/algorithm-parameters',
                name: 'algorithmParameters',
                component: () => import('./otp/views/dispatchManage/algorithmParameters/Main'),
                meta: { title: 'otp.route.algorithmParameters', system: 'tms' }
            },
            {
                path: '/otp/dispatch-Manage/limit-line-areas',
                name: 'limitLineAreas',
                component: () => import('./otp/views/dispatchManage/limitLineAreas/Main'),
                meta: { title: 'otp.route.limitLineAreas', system: 'tms' }
            },
            {
                path: '/otp/dispatch-Manage/single-list',
                name: 'singleList',
                component: () => import('./otp/views/dispatchManage/singleList/Main'),
                meta: { title: 'otp.route.singleList', system: 'tms' }
            },
            {
                path: '/otp/dispatch-Manage/single-list-detail',
                name: 'singleListDetail',
                component: () => import('./otp/views/dispatchManage/singleList/singleListDetail/Main'),
                meta: { title: 'otp.route.singleListDetail', system: 'tms' }
            },
            {
                path: '/otp/dispatch-Manage/train-list',
                name: 'trainList',
                component: () => import('./otp/views/dispatchManage/trainList/Main'),
                meta: { title: 'otp.route.trainList', system: 'tms' }
            },
            {
                path: '/otp/dispatch-Manage/train-list-adjust',
                name: 'trainListAdjust',
                component: () => import('./otp/views/dispatchManage/trainList/adjust/Main'),
                meta: { title: 'otp.route.trainListAdjust', system: 'tms' }
            },
            {
                path: '/otp/dispatch-Manage/train-list-detail',
                name: 'trainListDetail',
                component: () => import('./otp/views/dispatchManage/trainList/detail/Main'),
                meta: { title: 'otp.route.trainListDetail', system: 'tms' }
            },
            {
                path: '/otp/dispatch-Manage/vehicleCard-manage',
                name: 'vehicleCardManage',
                component: () => import('./otp/views/dispatchManage/vehicleCardManage/Index'),
                meta: { title: 'otp.route.vehicleCardManage', system: 'tms' }
            },
            {
                path: '/otp/dispatch-Manage/driver-manage',
                name: 'driverManage',
                component: () => import('./otp/views/dispatchManage/driverManage/Index'),
                meta: { title: 'otp.route.driverManage', system: 'tms' }
            }
        ]
    }
    // {
    //     path: '/otp/abnormal-billing',
    //     name: 'abnormalBilling',
    //     component: () => import('./otp/views/abnormalBilling/Main'),
    //     meta: { title: 'otp.route.abnormalBilling', system: 'tms' }
    // }
];
